import React from 'react';
import { Redirect, Route } from 'react-router-dom';
const PrivateRouteCompany = ({ component: Component, restricted, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      localStorage.getItem('isLogin') && restricted ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default PrivateRouteCompany;
